import { useDispatch } from "react-redux";
import { actions } from "redux-store";
import { EventTypes } from "redux-store/slices/events/events.interfaces";
import { useCallback, useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

export const useTutorialPage = () => {
  const [step, setStep] = useState(0);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isTallEnough = useMediaQuery("(min-height:650px)");

  const goToNextStep = useCallback(() => {
    setStep((s) => Math.min(s + 1, 2));
  }, []);

  const goToPrevStep = useCallback(() => {
    setStep((s) => Math.max(s - 1, 0));
  }, []);

  const goToStep = useCallback((newStep: number) => {
    setStep(newStep);
  }, []);

  useEffect(() => {
    dispatch(
      actions.dispatchEvent({
        eventType: EventTypes.QUIZ_VIEW,
        extraData: { quizStepName: "Tutorial page" },
      }),
    );
  }, [dispatch]);

  return { goToNextStep, goToPrevStep, step, goToStep, isMobile, isTallEnough };
};
